
import {
	Component,
	Vue
} from 'vue-property-decorator';
import RadioButton from '@/components/radio-button.vue';
import PageFooter from '@/components/page-footer.vue';
import PickerDate from '@/components/picker-date.vue';
import Dialog from '@/components/dialog.vue';
import uploadImg from '@/components/upload-img.vue';
import Message from '@/components/message.vue';
import AddressSelect from '@/components/address-select.vue';
import receiptView from './components/receipt-view.vue';

import {
	orderStates,
	timeScope,
	grade,
} from '@/utils/config';
import {
	orderList,
	orderCheck,
	getReportForms,
	getLogisticsExcelUrl,
	orderInfo,
	ordereditReceiveAddress,
	orderisForceAllowSupport,
	orderclose,
	ordercloseImport,
	ordercloseWithoutRefund,
	ordercopyOrderInfo,
} from '@/api/order'
import {
	productCategory,
	productOpenTimeLabelFilterList
} from "@/api/supplier"
import {
	getOssToken
} from '@/api/user'
import {
	downloadFile
} from '@/utils/index';
import {
	getSearchDate,
	nextDay
} from "@/utils/index"
import {
	handleClipboard
} from '@/utils/clipboard'
import searchOrderDialog from "@/components/searchOrderDialog.vue"

let time = new Date().toLocaleDateString().replace(/\//g, '-');

@Component({
	name: 'order-list',
	components: {
		RadioButton,
		PageFooter,
		PickerDate,
		'slz-dialog': Dialog,
		'slz-message': Message,
		'upload-img': uploadImg,
		AddressSelect,
		receiptView,
		searchOrderDialog
	}
})



export default class OrderList extends Vue {
	private roleMap: any = grade;
	private radioType = null;
	private radioList: any = orderStates;
	private orderNumKey: any = ''
	private productNameKey = ''
	private productPhone = ''
	private sequence = ''
	private pageNo = 1;
	private pageSize = 10;
	private total = 0;
	private receiptKey: any = ''
	private submitKey: any = ''
	private filterTime: any = '';
	private radioTime: any = 0;
	private radioTimes = timeScope;
	private orderState = {
		'check_pending': {
			name: '待审核',
			color: 'blue'
		},
		'cancel': {
			name: '已取消',
			color: 'gary'
		},
		'timeout_cancel': {
			name: '超时取消',
			color: 'gary'
		},
		'complete': {
			name: '已完成',
			color: 'green'
		},
		'refund': {
			name: '已售后',
			color: 'red'
		},
		'processing': {
			name: '待发货',
			color: 'yellow'
		},
		'transport': {
			name: '已发货',
			color: 'yellow'
		}
	}
	private list: any = []
	private showCheckLog = false; // 展示审核记录
	private checkLogs: any = [];
	private currentId = 0;
	private showMessage = false;
	private showImportExel = false;
	private uploadToken: any = {};
	private importInvoice = ''; // 导入发货单的url
	private showExportOrder = false;
	private exportOrder: any = {
		title: '导出报表',
		type: 0, // 0 报表 1 导出发货单 2 导出发货单（客服)
	};
	private exportLoopTime: any = null;
	private excelPwd = '';
	private exportLoading = false;

	private openTimeLabel = '';
	private openTimeLabelList: any = [];

	private popPageNo = 1;
	private popPageSize = 10;
	private popTotal = 0;
	private popId = 0;

	private rowmsg: any = {}
	private itemmsg: any = {}
	private changeaddressShow = false
	private changeaddressMsg: any = {
		OrderNo: '',
		ReceiveName: '',
		ReceivePhone: '',
		ReceiveProvince: '',
		ReceiveCity: '',
		ReceiveArea: '',
		ReceiveAddress: ''
	}

	private tableloading = false
	private receiptShow = false
	private receiptOrderNo = ''

	private aftersalesShow = false

	private closeShow = false
	private closereason = ''
	private closeloading = false

	private batchShow = false
	private filemsg = {
		ExcelFilePath: '',
		ExcelFileName: '',
		FailCount: '',
		OrderCloseImportRecordId: ''
	}
	private batchcanclosetype = 1
	private paytype = null
	private paytypelist = [
		{ value: null, label: '全部' },
		{ value: true, label: '在线支付' },
		{ value: false, label: '线下支付' },
	]
	private offlinerefundShow = false
	private offlinerefundloading = false
	private offlinerefundreason = ''

	private categoryList: any = [];
	private categoryId = null;

	private IsTest = true
	private orderdetail: any = {}
	private searchOrderShow = false





	private mounted() {
		this.filterTime = getSearchDate(2, true).join('/')
		// this.getList()
		this.IsTest = (location.origin.indexOf('localhost') > -1 || location.origin == 'http://testbackend.routuan.com')
	}
	activated() {
		// this.filterTime = getSearchDate(2).join('/')
		this.getProductCategory()
		this.getOpenTimeLabel();
		this.getList()
	}



	private copyaftersales(event) {
		let text = ''
		text += '★订单编号：' + this.orderdetail.OrderNo + '\n'
		text += '★下单人：' + this.orderdetail.CustomerName + '  ' + this.orderdetail.CustomerPhone + '\n'
		text += '★下单时间：' + this.orderdetail.AddTime + '\n'
		text += '★订单审核序列：' + this.orderdetail.RoleGradeSequence + '\n'
		text += '★订单商品明细：' + '\n'
		for (let item of this.orderdetail.ProductInfoList) {
			text += item + '\n'
		}
		text += '★订单状态：' + this.orderdetail.OrderStateValue + '\n'

		text += '★收件信息：' + this.orderdetail.ReceiveName + '。' + this.orderdetail.ReceivePhone + '。' +
			this.orderdetail.ReceiveProvince + this.orderdetail.ReceiveCity + this.orderdetail.ReceiveArea + this.orderdetail.ReceiveAddress + '。' + '\n'
		text += '★买家备注：' + (this.orderdetail.CustomerRemark || '无') + '\n'
		text += '★订单金额：' + this.orderdetail.OrderMoney + `(含运费${this.orderdetail.FreightMoney})` + `(含退换无忧${this.orderdetail.BuyFreightInsuranceMoney})` + '\n'
		text += '★优惠情况：' + `优惠券${this.orderdetail.ActivityCouponMoney}元、红包${this.orderdetail.RedPacketMoney}元、满减${this.orderdetail.ActivityMarkdownMoney}元、随心选优惠${this.orderdetail.ActivityOnePriceDiscountMoney}元、跨境随机优惠${this.orderdetail.CrossPayRandomPromotionMoney}元` + '\n'
		text += '★发货明细：' + this.orderdetail.CustomerRemark + '\n'
		for (let item of this.orderdetail.ExpressInfoList) {
			text += item + '\n'
		}
		text += '★补充描述：'
		handleClipboard(text, event)
	}
	private async getorderdetail(row) {
		let res = await ordercopyOrderInfo({
			OrderNo: await row.OrderNo
		})
		if (res.IsSuccess) {
			this.orderdetail = res.Result
			return true
		}
	}
	private async tocopy(row) {
		try {
			await this.getorderdetail(row);
			this.$nextTick(() => {
				setTimeout(() => {
					let copy = document.getElementById('copy') as any
					copy.click()
				}, 0);
			})
		} finally {
			//
		}
	}
	private async getProductCategory() {
		try {
			const res: any = await productCategory({
				Skip: 0,
				Take: 999999,
			});
			this.categoryList = res.Result.Results.map(item => {
				return {
					value: item.Id,
					label: item.CategoryName
				}
			});
		} catch (e) {
			console.log('productlist ===>', e)
		}
	}

	/**
	 * 获取开团日期标签
	 */
	private async getOpenTimeLabel(){
		try {
			const res: any = await productOpenTimeLabelFilterList({
				Skip: 0,
				Take: 999999,
			});
			this.openTimeLabelList = res.Result.map((item, i)=>{
				return {
					value: i,
					label: item.OpenTimeLabel
				}
			});
		} catch (e) {
			console.log('productlist ===>', e)
		}
	}

	private async confirmofflinerefund() {
		if (!this.offlinerefundreason) {
			this.$message.error('请输入退款原因')
			return
		}
		try {
			this.offlinerefundloading = true
			let res: any = await ordercloseWithoutRefund({
				OrderNo: this.rowmsg.OrderNo,
				CloseReason: this.offlinerefundreason,
				OrderDetailId: this.itemmsg.Id
			})
			if (res.IsSuccess) {
				this.$message.success('操作成功')
				this.offlinerefundShow = false
				this.getList()
			}
		} finally {
			this.offlinerefundloading = false
		}
	}
	private toofflinerefund(row, isitem, item) {
		this.offlinerefundreason = ''
		this.rowmsg = row
		this.itemmsg = item
		this.offlinerefundShow = true
	}
	private downloadresult() {
		let url = location.origin + '/pc/order/closeDownload'
		url += '?OrderCloseImportRecordId=' + this.filemsg.OrderCloseImportRecordId
		window.open(url)
	}
	private async batchImport() {
		if (!this.filemsg.ExcelFilePath) {
			this.$message({
				type: 'warning',
				message: '请上传表格'
			});
			return;
		}

		try {
			this.batchcanclosetype = 2
			let res = await ordercloseImport(this.filemsg)
			if (res.IsSuccess) {
				this.filemsg.FailCount = res.Result.FailCount
				this.filemsg.OrderCloseImportRecordId = res.Result.OrderCloseImportRecordId
			}
		} finally {
			this.batchcanclosetype = 3
		}
	}
	private batchCloseImport() {
		this.filemsg = {
			ExcelFilePath: '',
			ExcelFileName: '',
			FailCount: '',
			OrderCloseImportRecordId: ''
		}
		this.batchShow = false
		this.batchcanclosetype = 1
	}

	private batchuploadSuc(file, name) {
		this.filemsg.ExcelFilePath = file[0]
		this.filemsg.ExcelFileName = name
	}

	private async confirmcloseorder() {
		if (!this.closereason) {
			this.$message.error('请输入取消原因')
			return
		}
		try {
			this.closeloading = true
			let res: any = await orderclose({
				OrderNo: this.rowmsg.OrderNo,
				CloseReason: this.closereason,
				OrderDetailId: this.itemmsg.Id
			})
			if (res.IsSuccess) {
				this.$message.success('订单已关闭')
				this.closeShow = false
				this.getList()
			}
		} finally {
			this.closeloading = false
		}
	}
	private closeOrder(row, isitem, item) {
		this.closereason = ''
		this.rowmsg = row
		this.itemmsg = item
		this.closeShow = true
	}
	private async confirmaftersales() {
		let res = await orderisForceAllowSupport({
			OrderNo: this.rowmsg.OrderNo,
			IsForceAllowSupport: !this.rowmsg.IsForceAllowSupport
		})
		if (res.IsSuccess) {
			this.$message.success('操作成功')
			this.aftersalesShow = false
			this.getList()
		}
	}
	private openaftersales(row) {
		this.rowmsg = row
		// console.log(this.rowmsg.IsForceAllowSupport)
		this.aftersalesShow = true
	}
	private orderreceipt(row) {
		this.rowmsg = row;

		this.receiptOrderNo = row.OrderNo;
		// console.log(this.receiptOrderNo)
		this.receiptShow = true;
	}
	private async confirmchangeaddress() {
		if (!this.changeaddressMsg.ReceiveName) {
			this.$message.error('请完善收件人信息')
			return
		} else if (!this.changeaddressMsg.ReceivePhone) {
			this.$message.error('请完善收件电话')
			return
		} else if (!this.changeaddressMsg.ReceiveProvince || !this.changeaddressMsg.ReceiveCity || !this.changeaddressMsg.ReceiveArea) {
			this.$message.error('请选择省市区')
			return
		} else if (!this.changeaddressMsg.ReceiveAddress) {
			this.$message.error('请完善收货地址')
			return
		}

		try {
			let data = JSON.parse(JSON.stringify(this.changeaddressMsg))
			let res = await ordereditReceiveAddress(data)
			if (res.IsSuccess) {
				this.$message.success('修改成功')
				this.closechangeaddress()
				this.getList()
			}
		} finally {
			//
		}
	}

	private closechangeaddress() {
		this.changeaddressMsg = {
			OrderNo: '',
			ReceiveName: '',
			ReceivePhone: '',
			ReceiveProvince: '',
			ReceiveCity: '',
			ReceiveArea: '',
			ReceiveAddress: ''
		}
		this.changeaddressShow = false
	}
	// 获取省市信息
	private getAddress(list: string[]) {
		this.changeaddressMsg.ReceiveProvince = list[0];
		this.changeaddressMsg.ReceiveCity = list[1];
		this.changeaddressMsg.ReceiveArea = list[2];
		// console.log(list)
	}

	private async changeaddress(row) {
		try {
			let res = await orderInfo({ OrderNo: row.OrderNo })
			if (res.IsSuccess) {
				this.changeaddressMsg = {
					OrderNo: row.OrderNo,
					ReceiveName: res.Result.ReceiveName,
					ReceivePhone: res.Result.ReceivePhone,
					ReceiveProvince: res.Result.ReceiveProvince,
					ReceiveCity: res.Result.ReceiveCity,
					ReceiveArea: res.Result.ReceiveArea,
					ReceiveAddress: res.Result.ReceiveAddress
				}
				// console.log([this.changeaddressMsg.ReceiveProvince,this.changeaddressMsg.ReceiveCity,this.changeaddressMsg.ReceiveArea])
				this.changeaddressShow = true
				this.rowmsg = row
			}
		} finally {
			//
		}
	}

	private changetype() {
		this.pageNo = 1
		this.getList()
	}

	private changePage(e) {
		this.pageNo = +e;
		this.getList();
	}

	private doSearch() {
		if (!this.filterTime) {
			this.$message.error('请选择下单时间')
			return
		}
		var dt = this.filterTime.split('/')
		let StartTime = dt[0]
		let EndTime = dt[1]
		let time = (new Date(EndTime).getTime() - new Date(StartTime).getTime()) / 1000 / 60 / 60 / 24
		if (this.sequence) {
			if (time > 31) {
				this.$message.error('跨度不允许超过31天')
				return
			}
		} else {
			if (time > 180) {
				this.$message.error('跨度不允许超过180天')
				return
			}
		}
		this.pageNo = 1;
		this.getList();
	}

	private clearSearch() {
		this.pageNo = 1;
		this.orderNumKey = '';
		this.productNameKey = '';
		this.receiptKey = '';
		this.submitKey = '';
		this.paytype = null
		this.sequence = ''
		this.openTimeLabel = ''
		this.filterTime = getSearchDate(2, true).join('/')
		this.categoryId = null
		this.getList();
	}

	private handleClickRow(row: any, column: any) {
		if (column.label === '操作' || column.label === '订单编号') return;
		const $table: any = this.$refs.multipleTable
		$table.toggleRowExpansion(row)
	}

	private async getList() {
		let params: any = {
			Skip: (this.pageNo - 1) * this.pageSize,
			Take: this.pageSize,
			OrderState: this.radioType == 5 ? 0 : this.radioType,
			OrderNo: this.orderNumKey,
			ProductName: this.productNameKey,
			ReceiveName: this.receiptKey,
			CustomerInfo: this.submitKey,
			SubmitterPhone: this.sequence,
			IsWaitingPay: this.radioType == 5,
			IsOnlinePay: this.paytype,
			ProductCategoryId: this.categoryId,
			OpenTimeLabel: this.openTimeLabelList[this.openTimeLabel]?.label
		}

		if (this.filterTime) {
			var dt = this.filterTime.split('/');
			params.StartTime = dt[0];
			params.EndTime = nextDay(dt[1], 0, 1)
		}

		try {
			this.tableloading = true
			const res: any = await orderList(params);
			this.list = res.Result.Results
			this.total = res.Result.Total;
			if (this.orderNumKey.value) {
				this.$nextTick(() => {
					const $table: any = this.$refs.multipleTable
					$table.toggleRowExpansion(this.list[0], true)
				})
			}
		} catch (e) {
			console.log(e)
		} finally {
			this.tableloading = false
		}
	}

	private popChangePage(e) {
		this.popPageNo = e;
		this.showLog(this.popId);
	}

	private async showLog(id: number) {
		this.popId = id;
		try {
			const res: any = await orderCheck({
				Skip: (this.popPageNo - 1) * this.popPageSize,
				Take: this.popPageSize,
				OrderNo: id
			})
			this.checkLogs = res.Result.Results;
			this.popTotal = res.Result.Total;
			this.showCheckLog = true;
		} catch (e) {
			console.log(e)
		}
	}

	private handleClose() {
		this.showCheckLog = false;
	}

	/**
	 * @func 跳转到订单详情
	 */
	private toDetail(id: number) {
		this.$router.push({
			name: 'Order_Detail',
			query: {
				id: id + ''
			}
		})
	}

	/**
	 * @func 跳转到售后申请页面
	 */
	private toAfterSales(id: number, state: string) {
		let type = state === 'processing' ? 1 : 0;
		this.$router.push({
			name: 'Order_Aftersales',
			query: {
				id: id + '',
				type: type + ''
			}
		})
	}

	/**
	 * @func 取消售后按钮
	 */
	private cancelAfterSales(id: number) {
		this.currentId = id;
		this.showMessage = true;
	}

	// 执行取消售后
	private handleConfirm() {
		console.log(this.currentId)
	}

	// 操作导入发货单
	private handleImport() {
		this.getToken()
		this.showImportExel = true;
	}

	// 上传发货单成功
	private uploadSuc(list: any) {
		this.importInvoice = list[0]
	}

	// 获取token
	private async getToken() {
		try {
			const res: any = await getOssToken({})
			this.uploadToken = {
				AccessKeySecret: res.access_key_secret,
				OSSAccessKeyId: res.access_key_id,
				SecurityToken: res.security_token
			}
		} catch (e) {
			console.error('getOssToken ===>', e)
		}
	}

	// 关闭导入发货单弹窗
	private handleCloseImport() {
		this.showImportExel = false;
		this.importInvoice = ''
	}

	// 导入发货单
	private async handleConfirmImport() {
		try {
			console.log(this.importInvoice)
		} catch (err) {
			console.log(err)
		}
	}

	// 显示导出相关文件弹窗
	private handleExport(title: string, type: number) {
		this.showExportOrder = true;
		this.exportOrder = {
			title: title,
			type: type
		}
	}

	// 关闭弹窗
	private closeExportOrder() {
		this.exportLoading = false;
		this.exportLoading = false;
		clearInterval(this.exportLoopTime);
		this.exportLoopTime = null;
		this.showExportOrder = false;
	}

	// 导出excel
	// private async exportFile() {
	// 	let params: any = {
	// 		filter: this.radioType,
	// 		order_time: this.radioTime
	// 	}
	// 	if (this.selectType === 0 && this.orderNumKey) {
	// 		if (this.orderNumKey.value.indexOf('-') !== -1) {
	// 			params.order_str_id = this.orderNumKey.value.split('-')[0]
	// 		} else {
	// 			params.order_str_id = this.orderNumKey.value
	// 		}
	// 	}
	// 	if (this.productNameKey) {
	// 		params.product_name = this.productNameKey
	// 	}
	// 	if (this.receiptType === 0 && this.receiptKey) {
	// 		params.username = this.receiptKey.value
	// 	}
	// 	if (this.receiptType === 1 && this.receiptKey) {
	// 		params.phone = this.receiptKey.value
	// 	}
	// 	if (this.selectTime === 0 && this.filterTime) {
	// 		let times: any = this.filterTime.value.split('/')
	// 		params.begin_time = parseInt('' + new Date(times[0] + ' 00:00:00').getTime() / 1000);
	// 		params.end_time = parseInt('' + new Date(times[1] + ' 23:59:59').getTime() / 1000);
	// 	}
	// 	if (!params.begin_time || !params.end_time) {
	// 		this.$message('请选择下单时间')
	// 		this.closeExportOrder()
	// 		return
	// 	}
	// 	this.showExportOrder = true
	// 	this.exportLoading = true
	// 	try {
	// 		const res: any = await getReportForms(params)
	// 		let curid = res.id || 0
	// 		let index = 0
	// 		if (!curid) {
	// 			this.$message({
	// 				type: 'error',
	// 				message: '导出失败'
	// 			})
	// 			this.closeExportOrder()
	// 			return
	// 		}
	// 		this.exportLoopTime = setInterval(() => {
	// 			this.exportFileReq(curid, index)
	// 			index++
	// 		}, 3000)
	// 	} catch (err) {
	// 		console.log(err)
	// 		this.closeExportOrder()
	// 	}
	// }

	private async exportFileReq(id: number, index: number) {
		try {
			const res: any = await getLogisticsExcelUrl({
				id
			});
			if (res.logistics_url) {
				downloadFile(res.logistics_url);

				this.closeExportOrder()
			} else {
				if (index >= 30) {
					this.$message({
						type: 'error',
						message: '导出失败'
					})
					this.closeExportOrder()
					return;
				}
			}
		} catch (err) {
			this.$message({
				type: 'error',
				message: '导出失败'
			})
			this.closeExportOrder()
		}
	}

	private exportExcel() {
		var url = location.origin + '/pc/order/orderQueryList/export?';
		url += 'OrderState=' + (this.radioType === null ? '' : (this.radioType == 5 ? 0 : this.radioType));
		url += '&OrderNo=' + encodeURIComponent(this.orderNumKey);
		url += '&ProductName=' + encodeURIComponent(this.productNameKey);
		url += '&ReceiveName=' + encodeURIComponent(this.receiptKey);
		url += '&CustomerInfo=' + encodeURIComponent(this.submitKey);
		url += '&SubmitterPhone=' + this.sequence;
		url += '&IsWaitingPay=' + (this.radioType == 5);
		url += '&IsOnlinePay=' + (this.paytype == null ? '' : this.paytype);
		url += '&ProductCategoryId=' + (this.categoryId == null ? '' : this.categoryId);

		if (this.openTimeLabelList[this.openTimeLabel]?.label){
			url += '&OpenTimeLabel=' + this.openTimeLabelList[this.openTimeLabel]?.label
		}
		
		if (this.filterTime) {
			var dt = this.filterTime.split('/');
			url += '&StartTime=' + dt[0];
			url += '&EndTime=' + nextDay(dt[1], 0, 1)
		}
		window.open(url)

	}
}
